export default __webpack_public_path__ + "static/n_00-bb92c1be9bb1f7b7c732e44fadca8ac4.png";